// src/components/ClickableSentence.js
import React from 'react';
import WordLookup from './WordLookup';
import ChineseLookup from './ChineseLookup';
import processSentenceJisho from '../utils/processSentenceJisho';
import logger from '../utils/logger';

const ClickableSentence = ({ sentence, lookupKey, language, baseLanguage: baseLanguageProp, lemmatizeSavedWord = false }) => {
    const currentLanguage = language || localStorage.getItem('learningLanguage') || 'Spanish';
    // Use prop first, then localStorage, then English
    const baseLanguage = baseLanguageProp || localStorage.getItem('baseLanguage') || 'English';

    if (
        currentLanguage === 'Japanese' &&
        React.isValidElement(sentence) &&
        sentence.type === 'span' &&
        sentence.props.className === 'japanese-sentence'
    ) {
        return <p className="story-text story-sentence japanese-sentence-processed">{sentence}</p>;
    }

    if (
        currentLanguage === 'Chinese' &&
        React.isValidElement(sentence) &&
        sentence.type === 'span' &&
        sentence.props.className === 'chinese-sentence'
    ) {
        return <p className="story-text story-sentence chinese-sentence-processed">{sentence}</p>;
    }

    if (currentLanguage === 'Chinese' && Array.isArray(sentence)) {
        const originalSentenceForContext = sentence.join('');
        return (
            <p className="story-text story-sentence chinese-sentence-processed">
                {sentence.map((word, index) => (
                    <ChineseLookup
                        key={`${lookupKey}-chinese-${index}-${word}`}
                        word={word}
                        sentence={originalSentenceForContext}
                        baseLanguage={baseLanguage}
                    >
                        {word}
                    </ChineseLookup>
                ))}
            </p>
        );
    }

    if (typeof sentence === 'string') {
        let sentenceStr = sentence;
        let processedSentence;

        if (currentLanguage === 'Japanese') {
            processedSentence = processSentenceJisho(sentenceStr, lookupKey);
        } else if (currentLanguage === 'Chinese') {
            logger.warn('ClickableSentence: Received string for Chinese, expected array. Rendering as plain text.');
            processedSentence = sentenceStr;
        } else {
            const words = sentenceStr.split(' ').filter(Boolean);
            processedSentence = (
                <>
                    {words.map((word, index) => (
                        <WordLookup
                            key={`${lookupKey}-other-${index}-${word}`}
                            word={word}
                            lookupKey={lookupKey}
                            language={currentLanguage}
                            sentence={sentenceStr}
                            baseLanguage={baseLanguage}
                            lemmatizeSavedWord={lemmatizeSavedWord}
                        >
                            {word}
                        </WordLookup>
                    ))}
                </>
            );
        }

        logger.debug(`ClickableSentence - Rendering for language "${currentLanguage}":`, sentenceStr);
        return (
            <p className="story-text story-sentence">
                {processedSentence}
            </p>
        );
    }

    if (React.isValidElement(sentence)) {
        logger.debug('ClickableSentence: Rendering provided React element directly.');
        return <p className="story-text story-sentence">{sentence}</p>;
    }

    logger.warn('ClickableSentence: Received unexpected sentence data type:', sentence);
    return <div className="story-text">{String(sentence)}</div>;
};

export default ClickableSentence;